<script>
	import { Button, Col, Row } from "@sveltestrap/sveltestrap";
	import { form, field } from "svelte-forms";
	import { required } from "svelte-forms/validators";
	import ErrorMessageHandler from "../../../../components/ErrorMessageHandler/ErrorMessageHandler.svelte";
	import Loader from "../../../../components/Loader/Loader.svelte";
	import PageHeader from "../../../../components/PageHeader/PageHeader.svelte";
	import { api } from "../../../../services/helpers";
	import {
		errorMessage,
		loading,
		masterData,
		vehicleEditData,
	} from "../../../../store/store";
	import { navigate } from "svelte-routing";
	import { filedrop } from "filedrop-svelte";
	import CustomSelect from "../../../../components/CustomSelect/CustomSelect.svelte";
	let files;
	let options = {
		accept: "image/*",
	};

	const carMake = field("carMake", $vehicleEditData.vehicleMakeId, [
		required(),
	]);
	const carModel = field("carModel", $vehicleEditData.vehicleModelId, [
		required(),
	]);
	const carColor = field("carColor", $vehicleEditData.vehicleColorId, [
		required(),
	]);
	const vehicleImages = field(
		"vehicleImages",
		$vehicleEditData.vehicleImages || [],
		[required()]
	);

	const myForm = form(carMake, carModel, carColor);

	let isImageEmty = "0";
	let duplicateId;

	$: filteredModel =
		$carMake.value == ""
			? $masterData.vehicleModels
			: $masterData.vehicleModels.filter(
					(model) => model.makeId == $carMake.value
				);

	async function handleSubmit() {
		if ($vehicleImages.value.length === 0) {
			isImageEmty = "";
		}

		const formData = new FormData();
		formData.append("id", $vehicleEditData.id);
		formData.append("vehicleMakeId", $carMake.value);
		formData.append("vehicleModelId", $carModel.value);
		formData.append("vehicleColorId", $carColor.value);

		for (let i = 0; i < $vehicleImages.value.length; i++) {
			if ($vehicleImages.value[i].file) {
				formData.append("vehicleImages", $vehicleImages.value[i].file);
			} else {
				formData.append("vehicleImages", $vehicleImages.value[i]);
			}
		}

		try {
			loading.set(true);
			const res = await api(
				"/v1/photos",
				"Vehicle",
				"PUT",
				formData,
				{},
				localStorage.getItem("token"),
				"multipart"
			);

			if (res?.status === 200) {
				navigate("/master-data/vehicle-data/vehicle-photos");
			}

			loading.set(false);
			if (res?.status == 400) {
				duplicateId = "Duplicate Id";
			}

			// navigate("/car-management");
		} catch (error) {
			console.log(error.response);
			loading.set(false);
			errorMessage.set(error.response.data.title);
		}
	}

	let res = [];
	const onFileSelected = (e) => {
		files = e.detail.files;
		isImageEmty = "0";
		let reader;
		let result = [];

		for (let index = 0; index < files.accepted.length; index++) {
			reader = new FileReader();

			if (files) {
				reader.readAsDataURL(files.accepted[index]);
				reader.onload = (e) => {
					$vehicleImages.value = [
						...$vehicleImages.value,
						{
							file: files.accepted[index],
							preview: e.target.result,
						},
					];
				};
			}
		}
		res = result;
	};

	const handleRemove = (i) => {
		let arr = $vehicleImages.value.filter((val, index) => index !== i);
		$vehicleImages.value = arr;
	};

	let load = false;
	loading.subscribe((value) => {
		load = value;
	});

	let err;
	errorMessage.subscribe((value) => {
		err = value;
	});
</script>

<Row>
	<Col>
		<Col xs={6}>
			<ErrorMessageHandler message={err} />
		</Col>
		<div>
			<PageHeader title="Edit Vehicle photos" />
			<Col>
				<Row>
					<Col>
						<label for="mandatory" class="d-block mb-3">
							<span>*Mandatory fields</span>
						</label>
					</Col>
				</Row>
			</Col>
			<Col>
				<Row>
					<Col>
						<label for="priority" class="d-block mt-3">
							<span> <b>Vehicle Make*</b></span>
						</label>
					</Col>
				</Row>
				<Row>
					<Col xs={6}>
						<CustomSelect
							type="text"
							bind:value={$carMake.value}
							options={$masterData.vehicleMakes}
							error={$myForm.hasError("carMake.required")}
							errorText="Vehicle make is required"
							defaultOption="Select Vehicle Make"
						/>
					</Col>
				</Row>
			</Col>
			<Col>
				<Row>
					<Col>
						<label for="carModel" class="d-block mt-3">
							<span> <b>Vehicle Model*</b></span>
						</label>
					</Col>
				</Row>
				<Row>
					<Col xs={6}>
						<CustomSelect
							type="text"
							bind:value={$carModel.value}
							options={$carMake.value ? filteredModel : []}
							error={$myForm.hasError("carModel.required")}
							errorText="Vehicle model is required"
							defaultOption="Select Vehicle Model"
						/>
					</Col>
				</Row>
			</Col>

			<Col>
				<Row>
					<Col>
						<label for="carparkOwner" class="d-block mt-3">
							<span> <b>Vehicle color*</b> </span>
						</label>
					</Col>
				</Row>
				<Row>
					<Col xs={6}>
						<CustomSelect
							type="text"
							bind:value={$carColor.value}
							options={$masterData.vehicleColors}
							error={$myForm.hasError("carColor.required")}
							errorText="Vehicle color is required"
							defaultOption="Select Vehicle color"
						/>
					</Col>
				</Row>
			</Col><Col>
				<Row>
					<Col>
						<label for="carparkOwner" class="d-block mt-3">
							<span> <b>Car park Image*</b> </span>
						</label>
					</Col>
				</Row>
				<Row>
					<Col>
						<label for="carparkOwner" class="d-block">
							<span>Type: PNG or JPG / Size: less than 2MB </span>
						</label>
					</Col>
				</Row>
				<Row>
					<Col xs={2} md={2}>
						<div
							use:filedrop={options}
							on:filedrop={(e) => onFileSelected(e)}
							class="filedrop"
						>
							<svg
								xmlns="http://www.w3.org/2000/svg"
								viewBox="0 0 24 24"
								width="48"
								height="48"
								><path fill="none" d="M0 0h24v24H0z" /><path
									d="M1 14.5a6.496 6.496 0 0 1 3.064-5.519 8.001 8.001 0 0 1 15.872 0 6.5 6.5 0 0 1-2.936 12L7 21c-3.356-.274-6-3.078-6-6.5zm15.848 4.487a4.5 4.5 0 0 0 2.03-8.309l-.807-.503-.12-.942a6.001 6.001 0 0 0-11.903 0l-.12.942-.805.503a4.5 4.5 0 0 0 2.029 8.309l.173.013h9.35l.173-.013zM13 13v4h-2v-4H8l4-5 4 5h-3z"
								/></svg
							>
							<p>Upload photos</p>
						</div>
					</Col>
				</Row>
				<Row>
					<Col xs={6} md={6}>
						<Col xs={12}>
							<div class="">
								{#each $vehicleImages.value as src, index}
									<!-- svelte-ignore a11y-missing-attribute -->
									<!-- svelte-ignore a11y-missing-attribute -->
									<div class="container-checkbox me-2 my-2">
										<!-- svelte-ignore a11y-img-redundant-alt -->
										<img
											src={src.preview || src}
											style="width:100%; height:200px; object-fit: cover;"
											alt="vehicle preview"
										/>
										<!-- svelte-ignore a11y-click-events-have-key-events -->
										<img
											alt="delete vehicle preview"
											class="close"
											src="https://img.icons8.com/fluency/48/000000/delete-forever.png"
											on:click={() => handleRemove(index)}
										/>
									</div>
								{/each}
							</div>
						</Col>
						{#if !isImageEmty}
							<div>
								<p class="error-text">Image is required</p>
							</div>
						{/if}
					</Col>
				</Row>
			</Col>
			<Col class="d-flex justify-content-end">
				<Row>
					<Col>
						<Button class="themeButton" on:click={myForm.reset}
							>RESET</Button
						>
						<!-- svelte-ignore a11y-no-noninteractive-tabindex -->
						<span
							class="d-inline-block"
							data-bs-toggle={!$myForm.valid ? "tooltip" : ""}
							title={!$myForm.valid
								? "Fill all required field"
								: ""}
						>
							<Button
								class="themeButton primary"
								on:click={() => handleSubmit()}
								on:click={myForm.validate}
								disabled={!$myForm.valid}
							>
								{#if load}
									<Loader />
								{:else}
									EDIT
								{/if}
							</Button>
						</span>
					</Col>
				</Row>
			</Col>
		</div></Col
	>
</Row>

<style>
	.filedrop {
		background-color: #f0f0f0;
		height: 100px;
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		border-radius: 0.375rem;
		border: 0.7em dashed #c3c3c3;
		outline: 1em solid #f0f0f0;
		transition: border 0.3s ease-in-out;
		outline-offset: -1.3em;
		padding: 0.475em;
	}
	.filedrop:focus {
		border-color: #2196f3;
	}
	.filedrop:hover {
		border-color: #343434;
	}
	.filedrop p,
	.filedrop svg {
		transition: color 0.1s;
		transition: fill 0.1s;
	}
	.filedrop:focus p,
	.filedrop:focus svg {
		color: #2196f3;
		fill: #2196f3;
	}
	.filedrop:hover p,
	.filedrop:hover svg {
		color: #343434;
		fill: #343434;
	}

	.container-checkbox {
		position: relative;
		width: 30.3%;
		float: left;
	}

	.container-checkbox .close {
		display: block;
		width: 25px;
		height: 25px;
		position: absolute;
		top: 3px;
		right: 2px;
		overflow: hidden;
		text-indent: -9999px;
		cursor: pointer;
	}
</style>
